<div class="campos-relatorio-wrapper">
  <p-table [value]="campos" dataKey="id">

    <ng-template pTemplate="header">
      <tr>
        <th>Nome</th>
        <th>Valor</th>
        @if (mostrarTag) {
          <th>Tag no template</th>
        }
        @if (mostrarTag) {
          <th></th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-campo let-i="rowIndex">
      <tr>
        <td>
          @if (mostrarTag) {
            <input pInputText [id]="'campoRelatorioNome' + i" [(ngModel)]="campo.nome" class="input-full-width" />
          }
          @if (!mostrarTag) {
            {{ campo.nome }}
          }
        </td>
        <td>
          <textarea pTextarea [id]="'campoRelatorioValor' + i" rows="1" [(ngModel)]="campo.valor" class="input-full-width"></textarea>
        </td>
        @if (mostrarTag) {
          <td>
            <input pInputText [id]="'campoRelatorioTag' + i" [(ngModel)]="campo.tagHtmlPdf" class="campo-relatorio-tag" spellcheck="false" />
          </td>
        }
        @if (mostrarTag) {
          <td>
            <button mat-icon-button matTooltip="Remover" (click)="confirmarRemocao(campo)">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="mostrarTag ? 4 : 2">Nenhum campo do relatório</td>
      </tr>
    </ng-template>

  </p-table>

  @if (mostrarTag) {
    <button mat-stroked-button class="btn-adicionar-campo" (click)="adicionarCampo()">
      <i class="pi pi-plus"></i> Adicionar campo
    </button>
  }
</div>
